import * as React from "react";
import { DataTableBase, DataTableBaseProps } from "./DataTableBase";

export type DataTableComponentProps<T> = DataTableBaseProps & {
  data: T[];
};

export const DataTableComponent: <T>(props: DataTableComponentProps<T>) => React.ReactElement = 
<T,>(props: DataTableComponentProps<T>) => {
    const { data, ...rest } = props;

    return (
          <DataTableBase
            value={data}
            totalRecords={data.length} 
            {...rest}
          />
    );
};
